import React, { useState } from "react";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { Input, message } from "antd";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import { postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import PopupCard from "../../../../../components/Cards/PopupCard/PopupCard";

const CustomerAddNewSection = ({
  onOpen,
  onClose,
  setSectionCreated,
  popupData,
  setPopupData,
  clientId,
}) => {
  const [section, setsection] = useState("");
  const [error, setError] = useState(false);

  const handleClear = () => {
    setsection("");
    setError(false);
    onClose();
  };

  const handlePopupClose = () => {
    setPopupData(null);
  };

  const createSection = async (section, clientId) => {
    try {
      const body = {
        client_id: clientId,
        status: "Active",
        name: section,
        description: "This is description",
      };
      const response = await postApi({
        apiUrl: API_URLS.CREATE_CUSTOMER_SECTION,
        headers: { client: clientId },
        data: body,
      });

      if (response.success) {
        setPopupData({
          type: "success",
          title: "Section Created",
          message: "The new section was successfully created.",
        });
        onClose();
      } else {
        setPopupData({
          type: "warning",
          title: "Failed in Adding New Section",
          message: `${response.message}`,
        });
        onClose();
      }
    } catch (error) {
      console.error("Error in creating new Section", error);
      setPopupData({
        type: "error",
        title: "Creation Failed",
        message: error.message || "There was a problem creating the section.",
      });
      onClose();
    } finally {
      setTimeout(() => {
        setPopupData(null);
      }, 2000);
    }
  };

  const handleSave = async () => {
    if (!section.trim()) {
      setError(true);
      return;
    }
    await createSection(section, clientId);
  };

  return (
    <div className="flex justify-center my-4">
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl text-[#06513D] ">Add Section</h3>
          <div
            style={{
              border: "1px solid #ebedf3",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <div className="mb-4">
              <Input
                value={section}
                onChange={(e) => setsection(e.target.value)}
                placeholder="Enter Section Name"
                style={{
                  border: "1px solid #ebedf3",
                  borderRadius: "10px",
                  padding: "10px",
                }}
                className="text-base font-light"
              />
              {error && (
                <p className="text-red-500 text-sm mt-2">
                  Please fill out this field.
                </p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText="Cancel"
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleClear}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Save"
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleSave}
            />
          </div>
        </div>
      </DailogBox>
    </div>
  );
};

export default CustomerAddNewSection;
